import React, { ReactElement } from 'react';
import { className } from '../../../../../shared/helpers';
import styles from "./Pagination.module.scss";

interface IPaginationProps
{
    rowsPerPage: number;
    totalRows: number;
    paginate: Function;
    previousPage: Function;
    nextPage: Function;
    currentPage: number;
    totalLinks: number;
}

function Pagination({ rowsPerPage, totalRows, paginate, previousPage, nextPage, currentPage, totalLinks}: IPaginationProps): ReactElement
{
    const pageNumbers = [];
    const first = 1;
    let previous = currentPage - 1;
    let next = currentPage + 1;
    

    
    const last = Math.ceil(totalRows / rowsPerPage);

    if (previous < first)
            previous = first;

    if (next > last)
        next = last;

    const halfLinks = totalLinks / 2;
    let linkFrom = currentPage - halfLinks;
    let linkTo = currentPage + halfLinks;

    if (linkFrom < first)
    {
        linkTo += first - linkFrom;
    }
    if (linkTo > last)
    {
        linkFrom += last - linkTo;
    }
    if (linkFrom < first)
    {
        linkFrom = first;
    }
    if (linkTo > last)
    {
        linkTo = last;
    }

    for (let i= linkFrom; i <= linkTo ; i++ )
    {
        pageNumbers.push(i);
    }

    return (
        <div>
        <nav>
            <ul  className={styles.pagination}>
                <li>
                   <button onClick={() => paginate(first)}>
                   <span className="material-icons">first_page</span>
                   </button>
                </li>
                <li>
                   <button onClick={() => previousPage()}>
                   <span className="material-icons">chevron_left</span>
                   </button>
                </li>
                {pageNumbers.map( number => (
                    <li key={number} >
                            <button {...className({[styles.selectedButton]: currentPage === number}) } onClick={() => paginate(number)}>
                            {number}
                            </button>
                    </li>
                ))}
                <li>
                   <button onClick={() => nextPage()}>
                       <span className="material-icons">chevron_right</span>
                   </button>
                </li>
                <li>
                   <button onClick={() => paginate(last)}>
                       <span className="material-icons">last_page</span>
                   </button>
                </li>
            </ul>
        </nav>
        </div>
    )
}

export default Pagination;